import React from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

import { AddEdit } from "../../../SectionWiseClassification";

type Props = {
  handleOpenBidPanel: (type: AddEdit) => void;
};

const BidCreationBtn = ({ handleOpenBidPanel }: Props) => {
  const handleBidOpen = () => {
    handleOpenBidPanel("add");
  };
  return (
    <Stack direction="row" justifyContent="flex-end">
      <Button
        variant="contained"
        color="primary"
        size="small"
        onClick={handleBidOpen}
      >
        Create New Bid
      </Button>
    </Stack>
  );
};

export default BidCreationBtn;
